import type { Transaction } from '@api/hooks/types/getTransactions';
import { LeftArrowIcon, Typography } from '@gurupay/gp-ui-library';
import { formatNumberAmount } from '@utils/utils';

export const ApprovalsRenderers = {
	transactionInfo: ({ beneficiary, amount, payment_details, currency }: Transaction) => (
		<div className="flex items-center justify-between gap-space-8">
			<div className="w-0 min-w-0 flex-1">
				<Typography className="font-bold" level="small-text">
					{beneficiary.name}
				</Typography>

				<div className="flex min-w-0 items-center gap-space-4">
					<Typography className="shrink-0 font-medium" level="xsmall-text">
						{`${formatNumberAmount(amount.toFixed(2))} ${currency}`}
					</Typography>

					<Typography className="block min-w-0 flex-1 truncate" level="xsmall-text">
						{payment_details}
					</Typography>
				</div>
			</div>

			<div className="approval-icon flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-neutral-50 transition">
				<LeftArrowIcon className="h-4 w-4 rotate-180" />
			</div>
		</div>
	),
};
